<mat-icon *ngIf="show" (click)="openInfoDialog(); $event.stopPropagation();" aria-hidden="false" aria-label="{{tip}}" class="help-badge" matTooltip="{{tip}}">help
</mat-icon>
